import { render } from "./NotificacionCorreoComponent.vue?vue&type=template&id=b968cb06"
import script from "./NotificacionCorreoComponent.vue?vue&type=script&lang=js"
export * from "./NotificacionCorreoComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__